import React from "react";

import { AppLayout } from "layout";

import { RefundsData } from "modules/Refunds/components";
import { Grid } from "@mui/material";

type Props = {};

const RefundsContainer = (props: Props) => {

  return (
    <AppLayout>
      <Grid bgcolor={"#F8F8F8"} height={"100vh"}>
        <RefundsData />
      </Grid>
    </AppLayout>
  );
};

export default RefundsContainer;
